(function(){
'use strict';
function list(v){return Array.prototype.slice.call(v||[])}
function id(v){return String(v==null?'':v).split('/').pop()}
function init(root){
 var gallery=root.querySelector('[data-ura4-gallery]');
 if(!gallery||gallery.dataset.ura4GalleryReady==='true')return null;
 var stage=gallery.querySelector('[data-ura4-gallery-stage]');
 var slides=list(gallery.querySelectorAll('[data-ura4-slide]'));
 var thumbs=list(gallery.querySelectorAll('[data-ura4-thumb]'));
 if(!stage||!slides.length)return null;
 var arabicGallery=/^ar(?:-|$)/i.test(document.documentElement.lang||'');
 function galleryProductName(){var heading=root.querySelector('h1');return String(heading&&heading.textContent||gallery.getAttribute('data-ura4-product-name')||'URA').trim()}
 function galleryImageLabel(index){return galleryProductName()+'، الصورة '+(index+1)+' من '+slides.length}
 function localizeImageLabels(){
  if(!arabicGallery)return;
  slides.forEach(function(slide,index){var label=galleryImageLabel(index),picture=slide.querySelector('img'),open=slide.querySelector('[data-ura4-lightbox-open]');if(picture)picture.alt=label;slide.setAttribute('data-image-alt',label);if(open)open.setAttribute('aria-label','فتح الصورة '+(index+1)+' من '+slides.length+'، '+galleryProductName())});
  thumbs.forEach(function(thumb,index){thumb.setAttribute('aria-label','عرض الصورة '+(index+1)+' من '+slides.length)});
 }
 gallery.dataset.ura4GalleryReady='true';
 var current=gallery.querySelector('[data-ura4-gallery-current]');
 var total=gallery.querySelector('[data-ura4-gallery-total]');
 var prev=gallery.querySelector('[data-ura4-gallery-prev]');
 var next=gallery.querySelector('[data-ura4-gallery-next]');
 var all=gallery.querySelector('[data-ura4-gallery-all]');
 var active=0,frame=0,timer=0,visible=slides.map(function(n,i){return i}),lastColor=null;
 var suppressOpenUntil=0,stageTouch=null;
 var tour=gallery.querySelector('[data-ura4-tour]'),tourTimer=0,playing=false;
 var previews=gallery.querySelector('[data-ura4-previews]');
 function stopTour(){playing=false;clearTimeout(tourTimer);if(tour){tour.setAttribute('aria-pressed','false');tour.querySelector('[data-ura4-tour-label]').textContent=tour.dataset.playLabel;tour.querySelector('[data-ura4-tour-icon]').textContent='▷'}if(current)current.parentElement.setAttribute('aria-live','polite')}
 function scheduleTour(){clearTimeout(tourTimer);if(!playing)return;tourTimer=setTimeout(function(){if(!playing)return;go(active+1,false);scheduleTour()},active>0&&active<6?6500:4500)}
 if(tour)tour.addEventListener('click',function(){if(playing){stopTour();return}playing=true;tour.setAttribute('aria-pressed','true');tour.querySelector('[data-ura4-tour-label]').textContent=tour.dataset.pauseLabel;tour.querySelector('[data-ura4-tour-icon]').textContent='Ⅱ';if(current)current.parentElement.setAttribute('aria-live','off');scheduleTour()});
 if(previews)previews.addEventListener('click',function(){stopTour();var on=previews.getAttribute('aria-expanded')!=='true';previews.setAttribute('aria-expanded',String(on));gallery.dataset.previewsOpen=String(on)});
 root.addEventListener('pointerdown',function(e){if(!e.target.closest('[data-ura4-tour]'))stopTour()},{passive:true});
 root.addEventListener('keydown',function(e){if(!e.target.closest('[data-ura4-tour]'))stopTour()});
 root.addEventListener('change',stopTour);
 document.addEventListener('visibilitychange',function(){if(document.hidden)stopTour()});
 if('IntersectionObserver' in window)new IntersectionObserver(function(entries){if(!entries[0].isIntersecting)stopTour()},{threshold:.25}).observe(stage);
 function poolPosition(index){return Math.max(0,visible.indexOf(index))}

 slides.forEach(function(n){n.hidden=false});
 thumbs.forEach(function(n){n.hidden=false});
 if(all)all.hidden=true;
 if(total)total.textContent=String(slides.length).padStart(2,'0');
 function pairView(){return matchMedia('(min-width:990px)').matches&&slides.length>1}
 function lastStart(){return Math.max(0,slides.length-(pairView()?2:1))}
 function paint(index){
  localizeImageLabels();
  active=Math.max(0,Math.min(lastStart(),index));
  [active,(active+1)%slides.length,(active-1+slides.length)%slides.length].forEach(function(i){var img=slides[i].querySelector('img');if(img)img.loading='eager'});
  slides.forEach(function(n,i){var on=i===active||(pairView()&&i===active+1);n.classList.toggle('is-active',on);n.setAttribute('aria-hidden',on?'false':'true');var b=n.querySelector('[data-ura4-lightbox-open]');if(b)b.tabIndex=on?0:-1});
  thumbs.forEach(function(n,i){var on=i===active,shown=on||(pairView()&&i===active+1);n.classList.toggle('is-active',shown);if(on)n.setAttribute('aria-current','true');else n.removeAttribute('aria-current')});
  var firstThumb=thumbs[active],lastThumb=thumbs[Math.min(slides.length-1,active+(pairView()?1:0))];
  if(firstThumb&&lastThumb){
   var rail=firstThumb.parentElement,railRect=rail.getBoundingClientRect(),firstRect=firstThumb.getBoundingClientRect(),lastRect=lastThumb.getBoundingClientRect();
   var left=Math.min(firstRect.left,lastRect.left),right=Math.max(firstRect.right,lastRect.right);
   var shift=left<railRect.left?left-railRect.left-2:(right>railRect.right?right-railRect.right+2:0);
   if(Math.abs(shift)>1)rail.scrollBy({left:shift,behavior:'auto'});
  }
  if(current)current.textContent=String(poolPosition(active)+1).padStart(2,'0');
  if(total)total.textContent=String(visible.length).padStart(2,'0');
  if(prev)prev.disabled=visible.length<2;
  if(next)next.disabled=visible.length<2;
 }
 function go(index,smooth){
  var oldActive=active;
  paint(Math.max(0,Math.min(lastStart(),index)));
  if(playing&&oldActive!==active&&!matchMedia('(prefers-reduced-motion: reduce)').matches){var picture=slides[active].querySelector('img');if(picture&&picture.animate)picture.animate([{opacity:.25},{opacity:1}],{duration:500,easing:'ease-out'})}
  var target=slides[active];
  var stageRect=stage.getBoundingClientRect(),targetRect=target.getBoundingClientRect();
  var targetLeft=stage.scrollLeft+(targetRect.left-stageRect.left);
  stage.scrollTo({left:Math.round(targetLeft),behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'auto'});
 }
 function move(d){if(visible.length>1){var target=active+d;if(target>lastStart())target=0;if(target<0)target=lastStart();go(target,true)}}
 function bindGalleryArrow(button,direction){
  if(!button)return;
  button.addEventListener('click',function(e){
   if(e.cancelable)e.preventDefault();e.stopPropagation();stopTour();
   move(direction);
  });
 }
 bindGalleryArrow(prev,-1);
 bindGalleryArrow(next,1);
 thumbs.forEach(function(n,i){n.addEventListener('click',function(){go(i,true)})});
 gallery.addEventListener('keydown',function(e){if(e.target.closest('dialog'))return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
 stage.addEventListener('dragstart',function(e){if(e.target.closest('img,[data-ura4-lightbox-open]'))e.preventDefault()});
 stage.addEventListener('pointerdown',function(e){
  if((e.pointerType!=='touch'&&e.pointerType!=='pen')||e.isPrimary===false)return;
  stageTouch={id:e.pointerId,x:e.clientX,y:e.clientY};
 },{passive:true});
 stage.addEventListener('pointerup',function(e){
  if(!stageTouch||e.pointerId!==stageTouch.id)return;
  if(Math.abs(e.clientX-stageTouch.x)>8||Math.abs(e.clientY-stageTouch.y)>8)suppressOpenUntil=performance.now()+320;
  stageTouch=null;
 },{passive:true});
 stage.addEventListener('pointercancel',function(){stageTouch=null},{passive:true});
 stage.addEventListener('click',function(e){
  if(performance.now()<suppressOpenUntil&&e.target.closest('[data-ura4-lightbox-open]')){e.preventDefault();e.stopPropagation();}
 },true);
 stage.addEventListener('scroll',function(){
  if(matchMedia('(pointer:coarse)').matches)suppressOpenUntil=performance.now()+160;
  cancelAnimationFrame(frame);frame=requestAnimationFrame(function(){
   if(mouseDrag)return;
   var best=active,dist=Infinity,stageRect=stage.getBoundingClientRect();
   slides.forEach(function(n,i){if(n.hidden||i>lastStart())return;var d=Math.abs(n.getBoundingClientRect().left-stageRect.left);if(d<dist){dist=d;best=i}});
   if(best!==active)paint(best);
  });
 },{passive:true});
 var dialog=root.querySelector('[data-ura4-lightbox]');
 var boxImg=dialog&&dialog.querySelector('[data-ura4-lightbox-image]');
 var boxStage=dialog&&dialog.querySelector('[data-ura4-lightbox-stage]');
 var boxCurrent=dialog&&dialog.querySelector('[data-ura4-lightbox-current]');
 var boxTotal=dialog&&dialog.querySelector('[data-ura4-lightbox-total]');
 var boxClose=dialog&&dialog.querySelector('[data-ura4-lightbox-close]');
 var boxPrev=dialog&&dialog.querySelector('[data-ura4-lightbox-prev]');
 var boxNext=dialog&&dialog.querySelector('[data-ura4-lightbox-next]');
 var boxIndex=0,boxGesture=null,suppressBoxClickUntil=0;
 function renderBox(index){
  if(!boxImg)return;
  boxIndex=visible.indexOf(index)>=0?index:visible[0];
  var slide=slides[boxIndex],source=slide.querySelector('img'),open=slide.querySelector('[data-full-src]');
  boxImg.src=(open&&open.getAttribute('data-full-src'))||(source&&(source.currentSrc||source.src))||'';
  boxImg.alt=arabicGallery?galleryImageLabel(boxIndex):(source&&source.alt)||'';
  if(boxCurrent)boxCurrent.textContent=String(poolPosition(boxIndex)+1).padStart(2,'0');
  if(boxTotal)boxTotal.textContent=String(visible.length).padStart(2,'0');
  if(boxStage){boxStage.classList.remove('is-zoomed');boxStage.setAttribute('aria-pressed','false');boxStage.scrollTop=0;boxStage.scrollLeft=0;}
 }
 function openBox(index){stopTour();if(!dialog)return;renderBox(index);document.documentElement.classList.add('ura4-lightbox-open');if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');requestAnimationFrame(function(){if(boxClose)boxClose.focus()})}
 function closeBox(){if(!dialog)return;if(typeof dialog.close==='function'&&dialog.open)dialog.close();else dialog.removeAttribute('open');document.documentElement.classList.remove('ura4-lightbox-open')}
 slides.forEach(function(n,i){var b=n.querySelector('[data-ura4-image-frame],[data-ura4-lightbox-open]');if(b)b.addEventListener('click',function(){if(performance.now()>=suppressOpenUntil)openBox(i)})});
 var zoomButton=gallery.querySelector('[data-ura4-zoom]');if(zoomButton)zoomButton.addEventListener('click',function(){openBox(active)});
 var mouseDrag=null;
 stage.addEventListener('pointerdown',function(e){
  if(e.pointerType!=='mouse'||e.button!==0)return;
  mouseDrag={id:e.pointerId,x:e.clientX,start:stage.scrollLeft,moved:false};
  stage.focus({preventScroll:true});stage.setPointerCapture(e.pointerId);
 });
 stage.addEventListener('pointermove',function(e){
  if(!mouseDrag||e.pointerId!==mouseDrag.id)return;
  var dx=e.clientX-mouseDrag.x;
  if(Math.abs(dx)>5){mouseDrag.moved=true;stage.classList.add('is-dragging');suppressOpenUntil=performance.now()+350}
  if(mouseDrag.moved){e.preventDefault();stage.scrollLeft=mouseDrag.start-dx}
 });
 function endMouseDrag(e){
  if(!mouseDrag||e.pointerId!==mouseDrag.id)return;
  var gesture=mouseDrag;mouseDrag=null;stage.classList.remove('is-dragging');
  if(stage.hasPointerCapture(e.pointerId))stage.releasePointerCapture(e.pointerId);
  if(gesture.moved){suppressOpenUntil=performance.now()+350;var best=0,dist=Infinity;slides.forEach(function(s,i){if(i>lastStart())return;var d=Math.abs(s.getBoundingClientRect().left-stage.getBoundingClientRect().left);if(d<dist){best=i;dist=d}});go(best,true)}
 }
 stage.addEventListener('pointerup',endMouseDrag);
 stage.addEventListener('pointercancel',endMouseDrag);
 boxClose&&boxClose.addEventListener('click',closeBox);
 function bindLightboxArrow(button,direction){
  if(!button)return;
  button.addEventListener('click',function(e){
   e.preventDefault();e.stopPropagation();
   renderBox(visible[(poolPosition(boxIndex)+direction+visible.length)%visible.length]);
  });
 }
 bindLightboxArrow(boxPrev,-1);
 bindLightboxArrow(boxNext,1);
 if(boxStage){
  boxStage.addEventListener('pointerdown',function(e){
   if((e.pointerType!=='touch'&&e.pointerType!=='pen')||boxStage.classList.contains('is-zoomed'))return;
   boxGesture={id:e.pointerId,x:e.clientX,y:e.clientY,axis:'',lastX:e.clientX,lastTime:performance.now(),velocity:0};
  },{passive:true});
  boxStage.addEventListener('pointermove',function(e){
   if(!boxGesture||e.pointerId!==boxGesture.id||boxStage.classList.contains('is-zoomed'))return;
   var dx=e.clientX-boxGesture.x,dy=e.clientY-boxGesture.y;
   if(!boxGesture.axis){
    if(Math.max(Math.abs(dx),Math.abs(dy))<6)return;
    boxGesture.axis=Math.abs(dx)>Math.abs(dy)*1.08?'x':'y';
    if(boxGesture.axis==='x')try{boxStage.setPointerCapture(e.pointerId)}catch(_){}
   }
   if(boxGesture.axis!=='x')return;
   e.preventDefault();
   var now=performance.now(),dt=Math.max(1,now-boxGesture.lastTime);
   boxGesture.velocity=(e.clientX-boxGesture.lastX)/dt;
   boxGesture.lastX=e.clientX;boxGesture.lastTime=now;
  },{passive:false});
  boxStage.addEventListener('pointerup',function(e){
   if(!boxGesture)return;
   var gesture=boxGesture;boxGesture=null;
   try{if(boxStage.hasPointerCapture&&boxStage.hasPointerCapture(gesture.id))boxStage.releasePointerCapture(gesture.id)}catch(_){}
   if(gesture.axis!=='x'||boxStage.classList.contains('is-zoomed'))return;
   var dx=e.clientX-gesture.x;
   if(Math.abs(dx)>42||Math.abs(gesture.velocity)>.42){
    suppressBoxClickUntil=performance.now()+420;
    renderBox(visible[(poolPosition(boxIndex)+(dx<0?1:-1)+visible.length)%visible.length]);
   }
  });
  boxStage.addEventListener('pointercancel',function(){boxGesture=null});
  boxStage.addEventListener('click',function(e){
   if(performance.now()<suppressBoxClickUntil){e.preventDefault();return}
   var zoomed=boxStage.classList.toggle('is-zoomed');boxStage.setAttribute('aria-pressed',String(zoomed));
  });
 }
 if(dialog){dialog.addEventListener('click',function(e){if(e.target===dialog)closeBox()});dialog.addEventListener('close',function(){document.documentElement.classList.remove('ura4-lightbox-open')});dialog.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();renderBox(visible[(poolPosition(boxIndex)-1+visible.length)%visible.length])}else if(e.key==='ArrowRight'){e.preventDefault();renderBox(visible[(poolPosition(boxIndex)+1)%visible.length])}})}
 function variantIndex(variant){
  if(!variant)return-1;
  var variantId=id(variant.id),featured=id((variant.featured_image&&variant.featured_image.id)||(variant.featured_media&&variant.featured_media.id));
  var found=slides.findIndex(function(n){return String(n.dataset.variantIds||'').split(/\s+/).filter(Boolean).map(id).indexOf(variantId)>-1});
  if(found<0&&featured)found=slides.findIndex(function(n){return id(n.dataset.imageId)===featured});
  return found;
 }
 function filterForVariant(variant){
  stopTour();
  var found=variantIndex(variant),color=root.querySelector('[data-ura4-color-input]:checked');
  var chosen=String(color&&color.value||'').trim().toLowerCase();
  var changed=lastColor!==chosen;lastColor=chosen;
  // Color selection navigates the complete gallery; it never hides other photographs.
  slides.forEach(function(n,i){n.hidden=false;n.style.removeProperty('order');if(thumbs[i]){thumbs[i].hidden=false;thumbs[i].style.removeProperty('order')}});
  if(all)all.hidden=true;
  go(changed&&found>=0?found:active,false);
 }
 function showImageId(value,scroll){var target=id(value),found=slides.findIndex(function(n){return id(n.dataset.imageId)===target});if(found>=0)go(found,scroll!==false)}
 function showIndex(index,scroll){go(index,scroll!==false)}
 var galleryWidth=stage.clientWidth,galleryPair=pairView();
 function resizeGallery(){clearTimeout(timer);timer=setTimeout(function(){var width=stage.clientWidth,pair=pairView();if(width===galleryWidth&&pair===galleryPair)return;galleryWidth=width;galleryPair=pair;go(active,false)},100)}
 window.addEventListener('resize',resizeGallery,{passive:true});
 paint(0);
 return{filterForVariant:filterForVariant,showImageId:showImageId,showIndex:showIndex,getIndex:function(){return active},refresh:function(){slides.forEach(function(n){n.hidden=false});thumbs.forEach(function(n){n.hidden=false});paint(active)}};
}
window.URAProductGalleryV4={init:init};
})();





(function(){
 'use strict';
 if(window.__uraProductSupportReady)return;
 window.__uraProductSupportReady=true;
 var desktop=window.matchMedia('(min-width:761px) and (pointer:fine),(min-width:1024px)'),opener=null,hostObserver=null;
 function ready(){
  var host=document.querySelector('shopify-chat');
  if(!host||typeof host.show!=='function'||!document.querySelector('[data-ura4-support-chat]'))return false;
  document.body.setAttribute('data-ura-pdp-chat-ready','');
  if(!hostObserver){hostObserver=new MutationObserver(function(){if(!host.hasAttribute('open')&&opener){var target=opener;opener=null;if(target.isConnected)target.focus({preventScroll:true});}});hostObserver.observe(host,{attributes:true,attributeFilter:['open']});}
  return true;
 }
 document.addEventListener('click',function(event){
  var link=event.target.closest?.('[data-ura4-support-chat]');
  if(!link||!desktop.matches||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  var host=document.querySelector('shopify-chat');
  if(!host||typeof host.show!=='function')return;
  event.preventDefault();opener=link;
  try{Promise.resolve(host.show()).catch(function(){opener=null;location.assign(link.href);});}catch(error){opener=null;location.assign(link.href);}
 });
 document.addEventListener('shopify:section:load',ready);
 if(!ready()){
  var observer=new MutationObserver(function(){if(ready()){observer.disconnect();clearTimeout(timer);}});
  observer.observe(document.body,{childList:true,subtree:true});
  var timer=setTimeout(function(){observer.disconnect();},10000);
  if(window.customElements)customElements.whenDefined('shopify-chat').then(function(){if(ready()){observer.disconnect();clearTimeout(timer);}});
 }
}());
